import React from 'react';
import { CheckIcon, PenLineIcon } from 'lucide-react';
import { Container } from '../components/Container';
const bullets = ['Audit-ready trails on every document', 'Multi-party + multi-document signing', 'Zero per-envelope fees, ever'];
export function ESignature() {
  return <section className="border-y border-white/5 py-20 sm:py-28" data-id="element-720">
      <Container data-id="element-721">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-722">
          {/* Visual: e-signature pad mock */}
          <div className="relative" data-id="element-723">
            <div aria-hidden className="absolute -inset-x-8 -inset-y-6 rounded-[2rem] bg-accent/5 blur-3xl" data-id="element-724" />
            <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-zinc-950/80 shadow-2xl shadow-black/40 backdrop-blur" data-id="element-725">
              <img src="https://i.imgur.com/nJCSug5.png" alt="Pigeon e-signature interface" className="h-auto w-full" data-id="element-726" />
            </div>
          </div>

          {/* Copy */}
          <div data-id="element-727">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent" data-id="element-728"></div>
            <h2 className="mt-4 font-serif-display text-5xl leading-[1.0] tracking-tight text-white sm:text-6xl" data-id="element-729">
              E-Signature
              <br data-id="element-730" />
              and Forms
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400" data-id="element-731">
              Multi-party signing with full audit trails, built into every
              workflow. No extra costs, no per-envelope fees.
            </p>
          </div>
        </div>
      </Container>
    </section>;
}